import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  useTheme,
} from "@mui/material";
import { useGetProfileQuery } from "../../features/api/userApiSlice";
import * as Constant from "../../features/constant";


const WalletCard = ({ screens, token, selectedScreen }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleAppDownload = () => {
    const landingUrl = process.env.REACT_APP_APK_LANDING_URL;
    if (landingUrl) {
      window.open(landingUrl, "_blank");
    } else {
      window.location.href = `${window.location.origin}/${process.env.REACT_APP_APK}`;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        backgroundColor: process.env.REACT_APP_COLOR_WALLETCARD_BACKGROUND || theme.palette.walletScreen,
      }}
    >
      <Grid container pt={0} spacing={1} justifyContent="center">
        {screens?.map((screen) => {
          const isSelected = screen?.code === selectedScreen;

          return (
          <Grid
            item
            xs={3}
            key={screen?.code}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              p: 0,
            }}
            onClick={() => {
              const noTokenRequired = ["referral", "app"].includes(screen?.code?.toLowerCase());

              if (!token && !noTokenRequired) {
                navigate(Constant.getPath("/login"));
                return;
              }

              switch (screen?.code?.toLowerCase()) {
                case "promotion":
                case "vip":
                  navigate(Constant.getPath("/" + screen?.code));
                  break;
                case "app":
                  handleAppDownload();
                  break;
                case "referral":
                  if (process.env.REACT_APP_REPLACE_AFFILIATE_WITH_REFERRAL === "true") {
                    if (token) {
                      navigate(Constant.getPath("/referral"));
                    } else {
                      navigate(Constant.getPath("/login"));
                    }
                  } else {
                    // Original affiliate logic
                    const affiliateSite = process.env.REACT_APP_AFFILIATE_SITE;

                    navigate(Constant.getPath("/affiliate"), {
                      state: {
                        screen: "Affiliate",
                      }
                    });
                  }
                  break;
                case "messaging":
                  navigate(Constant.getPath("/messaging"));
                  break;
                default:
                  navigate(Constant.getPath("/profileWallet"), {
                    state: { screen: screen?.code },
                  });
              }
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                p: 0.5,
                backgroundColor: isSelected ? `${theme.palette.primary.main}25` : "transparent",
                border: isSelected ? `1.5px solid ${theme.palette.primary.main}` : "1.5px solid transparent",
              }}
            >
              {screen?.icon}
            </Box>
            <Typography
              textAlign="center"
              fontSize={10}
              fontWeight={isSelected ? 700 : 400}
              color={isSelected ? theme.palette.primary.main : (process.env.REACT_APP_COLOR_WALLETCARD_TEXT || "white")}
            >
              {screen?.label}
            </Typography>
          </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default WalletCard;
